import React from "react";
import { css } from "@emotion/core";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

export default () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(
          relativePath: {
            eq: "journal/anana-vestige-journal-product-background.png"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        loading="eager"
        css={css`
          position: absolute !important;
          width: 100%;
          height: 100%;
          bottom: 0;
          left: 0;

          img {
            object-fit: initial !important;
          }
        `}
        fluid={data.placeholderImage.childImageSharp.fluid}
      />
    )}
  />
);
